import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = ({ onBookAppointment }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    setMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-12 left-0 right-0 z-40 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0 cursor-pointer" onClick={() => navigate('/')} data-testid="header-logo">
            <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent" style={{ fontFamily: "'Playfair Display', serif" }}>
              Virtual CFO Consultancy
            </h1>
          </div>

          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <button onClick={() => navigate('/')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm">Home</button>
            <button onClick={() => navigate('/about')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm">About Us</button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm">Services</button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm">Pricing</button>
            <button onClick={() => window.location.href = '/blogs'} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm">Blogs</button>
            <button onClick={() => window.location.href = '/fdi'} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm" data-testid="nav-fdi-link">FDI India Entry</button>
            <Button onClick={onBookAppointment} className="bg-emerald-600 hover:bg-emerald-700 text-white transition-all duration-300 shadow-lg hover:shadow-xl text-sm">
              Book Consultation
            </Button>
          </div>

          <div className="md:hidden">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-gray-700 hover:text-emerald-600">
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-gray-200">
            <button onClick={() => { setMobileMenuOpen(false); navigate('/'); }} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors">Home</button>
            <button onClick={() => { setMobileMenuOpen(false); navigate('/about'); }} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors">About Us</button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors">Services</button>
            <button onClick={() => scrollToSection('pricing')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors">Pricing</button>
            <button onClick={() => { setMobileMenuOpen(false); window.location.href = '/blogs'; }} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors">Blogs</button>
            <button onClick={() => { setMobileMenuOpen(false); window.location.href = '/fdi'; }} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors">FDI India Entry</button>
            <div className="px-4">
              <Button onClick={onBookAppointment} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white">Book Consultation</Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
